interface FancyCardProps {
  children?: React.ReactNode;
  className?: string;
}

export function FancyCard({ children, className }: FancyCardProps) {
  return (
    <div className={`${className} bg-black relative p-2 border border-primary overflow-hidden`}>
      <div className="absolute inset-0 opacity-15">
        <svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%">
          <defs>
            <pattern patternUnits="userSpaceOnUse" height="40" width="40" id="grid">
              <path stroke="var(--color-primary)" d="M 40 0 L 0 0 0 40" strokeWidth="1" fill="none" />
              <path
                d="M 0 10 L 40 10 M 0 20 L 40 20 M 0 30 L 40 30"
                stroke="var(--color-primary)"
                strokeWidth="0.5"
                fill="none"
              />
              <path
                d="M 10 0 L 10 40 M 20 0 L 20 40 M 30 0 L 30 40"
                stroke="var(--color-primary)"
                strokeWidth="0.5"
                fill="none"
              />
            </pattern>
          </defs>
          <rect fill="url(#grid)" height="100%" width="100%" />
        </svg>
      </div>

      <div className="absolute inset-0 fancy-gradient" />

      <div className="relative">
        {children}
      </div>
    </div>
  );
}